import ContractingAddress from "features/contracting/models/ContractingAddress";
import CheckValueInfoItem from "features/shared/components/infoItem/CheckValueInfoItem";
import _ from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  address: ContractingAddress;
  hasCadastralInfo?: boolean;
};

const ContractingAddressSummary = ({ address, hasCadastralInfo }: Props) => {
  //translations
  const tLabels = useTranslation("contracting\\contracting").t;
  const tAddressType = useTranslation("shared\\enums\\addressEvidenceNumberType").t;

  // render
  if (hasCadastralInfo === true) {
    return (
      <>
        <CheckValueInfoItem
          title={tLabels("contractingAddressSummary.cadastralTerritory")}
          value={address.cadastralTerritory}
        />
        <CheckValueInfoItem
          title={tLabels("contractingAddressSummary.parcelNumber")}
          value={address.parcelNumber}
        />
        <CheckValueInfoItem title={tLabels("contractingAddressSummary.city")} value={address.city} />
        <CheckValueInfoItem title={tLabels("contractingAddressSummary.cityPart")} value={address.cityPart} />
        <CheckValueInfoItem title={tLabels("contractingAddressSummary.zipCode")}value={address.zipCode} />
      </>
    );
  } else {
    return (
      <>
        <CheckValueInfoItem title={tLabels("contractingAddressSummary.street")} value={address.street} />
        <CheckValueInfoItem
          title={tAddressType(address.evidenceNumberType!)}
          value={address.evidenceNumber}
        />
        <CheckValueInfoItem
          title={tLabels("contractingAddressSummary.houseNumber")}
          value={address.houseNumber}
        />
        <CheckValueInfoItem title={tLabels("contractingAddressSummary.city")} value={address.city} />
        <CheckValueInfoItem title={tLabels("contractingAddressSummary.cityPart")} value={address.cityPart} />
        <CheckValueInfoItem title={tLabels("contractingAddressSummary.zipCode")}value={address.zipCode} />
      </>
    );
  }
};

export default ContractingAddressSummary;
